import { render } from "./PropertyList.vue?vue&type=template&id=8f8275f8&ts=true"
import script from "./PropertyList.vue?vue&type=script&lang=ts"
export * from "./PropertyList.vue?vue&type=script&lang=ts"

import "./PropertyList.vue?vue&type=style&index=0&id=8f8275f8&lang=scss"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__